import { useDispatch } from 'react-redux'
import { Link, useHistory } from 'react-router-dom'
import { AccordionBody, AccordionHeader, AccordionItem, Col, Row } from 'reactstrap'
import contactProfiles from '../../api/contactProfiles/hooks'
import { ContactType } from '../../api/globalTypes'
import { MODAL_TYPES } from '../../common/constants'
import { showModal } from '../../store/modal'
import { setupDeleteCallback } from '../Modals/DeleteModal/utils'
import { ContactProfileAccordionItemProps } from './types'

const ContactProfileAccordionItem = (props: ContactProfileAccordionItemProps) => {
    const { contactId, profileId, item, profileViewData, contactType = ContactType.Person, isDemand = false, setActiveProfileId } = props

    const history = useHistory()
    const dispatch = useDispatch()
    const { mutate: deleteContactProfile } = contactProfiles.DeleteContactProfile.useMutation()

    const handleDelete = () => {
        const callbackId = 'delete-contact-profile'
        const payload = {
            modalType: MODAL_TYPES.DELETE_MODAL,
            modalProps: { callbackId },
        }

        setupDeleteCallback(payload.modalType, payload.modalProps, () =>
            deleteContactProfile({ contactId, profileId }, { onSuccess: () => setActiveProfileId('') })
        )

        dispatch(showModal(payload))
    }

    const demandHeader = (
        <>
            {item.propertyType ? `${item.propertyType?.name}` : ''} {item.contactProfileService ? `, ${item.contactProfileService?.name}` : ''}
            <span className="mx-1">({item?.totalPropertyCount})</span>
            <ul className="list-inline mb-0 justify-content-start ms-2">
                <li className="list-inline-item edit">
                    <Link
                        to={contactType === ContactType.Company ? `/companies/${contactId}/edit` : `/contacts/${contactId}/edit`}
                        onClick={(e) => {
                            e.preventDefault()
                            history.push({
                                pathname: contactType === ContactType.Company ? `/companies/${contactId}/edit` : `/contacts/${contactId}/edit`,
                                state: {
                                    activeTab: 'demand',
                                    profileId: item.id.toString(),
                                },
                            })
                        }}
                        className="text-edit d-inline-block edit-item-btn"
                    >
                        <i className="mdi mdi-pencil-outline fs-16"></i>
                    </Link>
                </li>
                <li className="list-inline-item">
                    <Link
                        to="#"
                        className="text-danger d-inline-block remove-item-btn"
                        onClick={(e) => {
                            e.preventDefault()
                            e.stopPropagation()
                            handleDelete()
                        }}
                    >
                        <i className="mdi mdi-trash-can-outline fs-16"></i>
                    </Link>
                </li>
            </ul>
        </>
    )

    const offerHeader = (
        <>
            {item.contactProfileService?.name}
            <span className="mx-1">({item?.totalPropertyCount})</span>
        </>
    )

    return (
        <AccordionItem className="border-0">
            <AccordionHeader targetId={profileId.toString()} className="contact-profile-accordion-header">
                <div className="d-flex align-items-center">{isDemand ? demandHeader : offerHeader}</div>
            </AccordionHeader>

            <AccordionBody accordionId={profileId.toString()}>
                <div className="accordion-body px-0">
                    {isDemand &&
                        profileViewData &&
                        profileViewData
                            .filter((viewItem) => viewItem.value)
                            .map((viewItem, index, arr) => (
                                <Row className={`align-items-start ${index !== arr.length - 1 ? 'mb-4' : ''}`} key={viewItem.id}>
                                    <Col sm={6}>
                                        <span className="flex-grow-1 text-primary fw-medium">{viewItem.label}:</span>
                                    </Col>
                                    <Col sm={6}>
                                        <span className="flex-grow-1 text-primary fw-light">{viewItem.value}</span>
                                    </Col>
                                </Row>
                            ))}
                </div>
            </AccordionBody>
        </AccordionItem>
    )
}

export default ContactProfileAccordionItem
